export default __webpack_public_path__ + "static/media/10.ec949f00.jpg";